<template>
  <LKPublicationsFormdataListModalContainer
    ref="modal"
    :title="title"
    @closed="$emit('closed')"
  >
    <div class="LKPublicationsFormdataListModal__wrapper">
      <LKMunMehFormsList
        :mun-meh="data"
        :spectator="spectator"
      />
    </div>
  </LKPublicationsFormdataListModalContainer>
</template>

<script>
import LKPublicationsFormdataListModalContainer
  from '@/views/LKPublications/formdata/LKPublicationsFormdataListModalContainer.vue'
import LKMunMehFormsList from '@/views/LKMunMeh/components/FormsListModal/LKMunMehFormsList.vue'


export default {
  name: 'LKMunMehFormView',
  components: {
    LKMunMehFormsList,
    LKPublicationsFormdataListModalContainer,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    spectator: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    async open() {
      await this.$nextTick()
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
  },
}
</script>

<style lang="scss">
.LKPublicationsFormdataListModal {
  width: 100%;
  max-width: 2000px !important;
  height: 100%;
  margin-right: auto;
  margin-left: auto;

  &__wrapper {
    height: calc(100% - 52px);
  }
}
</style>
